module.exports = {"hideFooterCTA":true}


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/data/webhosting/global-settings.json
// module id = CsC7
// module chunks = 0